import { Container, Copyright } from '@hg/stylizator/components'
import { SwarmbytesLogo } from '@hg/stylizator/illustrations'
import { Text } from '@hg/stylizator/typography'
import { Flex, desktop, themeColors, Spacing } from '@hg/stylizator/utils'
import * as React from 'react'
import styled from 'styled-components'

import { useGlobalState } from 'app/store'

const SwarmbytesFooter: React.FC = () => {
  const [menuItems] = useGlobalState('swarmbytesFooterMenu')

  return (
    <WrapperView>
      <Spacing top={6} />
      <Container>
        <ColumnsWrapper>
          <Flex flexDir="column" flex={6}>
            <SwarmbytesLogo width="153" height="26" fill="#fff" />
          </Flex>
          <Spacing top={4} />
          <MenuColumn>
            {menuItems?.[0]?.map((item, idx) => (
              <MenuItem key={idx} url={item.url}>
                {item.name}
              </MenuItem>
            )) ?? null}
          </MenuColumn>
          <MenuColumn>
            {(menuItems?.[1] &&
              menuItems?.[1]?.map((item, idx) => (
                <MenuItem key={idx} url={item.url}>
                  {item.name}
                </MenuItem>
              ))) ??
              null}
          </MenuColumn>
        </ColumnsWrapper>
        <Spacing top={13} />
        <Copyright copyright="© 2023 Swarmbytes. All rights reserved." />
      </Container>
      <Spacing top={2} />
    </WrapperView>
  )
}

const WrapperView = styled.footer`
  background-color: ${themeColors.slate['50']};
  color: white;
`

const ColumnsWrapper = styled(Flex)`
  flex-direction: column;

  @media ${desktop} {
    flex-direction: row;
  }
`

const MenuItem: React.FC<React.PropsWithChildren<{ url: string }>> = (props) => (
  <li style={{ paddingBottom: 16 }}>
    <Text type="label" color="white">
      <a href={props.url} rel="noopener">
        {props.children}
      </a>
    </Text>
  </li>
)

const MenuColumn = styled.ul`
  list-style-type: none;
  flex: 3;
  padding-left: 0;
`

export default React.memo(SwarmbytesFooter)
